import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=1705a6e6&scoped=true&"
import script from "./Sorting.vue?vue&type=script&lang=js&"
export * from "./Sorting.vue?vue&type=script&lang=js&"
import style0 from "./Sorting.vue?vue&type=style&index=0&id=1705a6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1705a6e6",
  null
  
)

export default component.exports